import { defineStore } from 'pinia';
import { Logger, User, UserProfile } from 'oidc-client-ts';
import {
  AdminLevel, AdminRole, levelOf, Oauth2App, UserData,
} from '@/components/backend';
import userManager from '@/components/oidc';

/**
 * this is where the global data is stored, to be accessible to the entire application
 * @see https://andreasstihl.atlassian.net/wiki/spaces/W/pages/4320985177/Dealer-Admin+Access+Matrix
 */
const useAppStore = defineStore('app', {
  state: () => ({
    principal: undefined as UserProfile | undefined, // the user logged in DDC
    tutorialsShowed: false,

    // controllers for global modals
    showOrganizationModal: undefined as string | undefined,
    showUserSyncModal: undefined as UserData | undefined,
    showTutorialsModal: undefined as boolean | undefined,
    // user preferences
    hideTutorialsOnStartup: false,
    // created/updated app
    oauth2client: undefined as Oauth2App | undefined,
  }),

  getters: {
    getMyAdminRole: (state) => state.principal?.admin_roles as AdminRole | undefined,
    myOrganization: (state) => state.principal?.dealer_org_id as string,
    myDisplayName: (state) => (
      !state.principal ? '' : `${state.principal.given_name} ${state.principal.family_name}`
    ),
    /**
     * I can edit a user if he has a lower admin-level, or I am superAdmin
     */
    canEditUser() {
      const myRole = this.getMyAdminRole;
      return (role?: AdminLevel) => myRole === 'superAdmin' || levelOf(myRole) > levelOf(role);
    },
  },

  actions: {
    setPrincipal(u?: User | null) {
      Logger.debug('store', `setPrincipal <${u?.profile?.sub}> [${u?.profile?.admin_roles}]`);
      this.principal = u?.profile;
    },
  },
});

userManager.events.addUserLoaded((cb) => {
  Logger.info('oidc', 'User loaded - save in store');
  useAppStore()
    .setPrincipal(cb);
});

userManager.events.addUserUnloaded(() => {
  Logger.info('oidc', 'User unloaded - remove from store');
  useAppStore()
    .setPrincipal(undefined);
});

export default useAppStore;
